module.exports = "https://static.wanderu.com/ui-react/_next/static/media/tech-crunch-x2.7360843a.png";